

import { useSmartQuery, useSmartMutation } from "@shared/api/queries/hooks";
import { QueryKeyFactory } from "@shared/api/queries/queryKeyFactory";
import { toast } from "@shared/hooks/use-toast";
import { CXCxDashboardApi } from "./api";

// Hook for consumer summary (original)
export const useConsumerSummary = (params: {
  remote_utility_id: any;
}) => {
  return useSmartQuery(
    QueryKeyFactory.module.cx.dashboard.consumerSummary(params), 
    () => CXCxDashboardApi.getSummary(params),
    
  );
};

// Hook for revenue trend
export const useRevenueTrend = (params: {
  remote_utility_id: any;
}) => {
  return useSmartQuery(
    QueryKeyFactory.module.cx.dashboard.revenueTrend(params),
    () => CXCxDashboardApi.getRevenueTrend(params),
   
  );
};

// Hook for service trend  
export const useServiceTrend = (params: {
  remote_utility_id: any;
}) => {
  return useSmartQuery(
    QueryKeyFactory.module.cx.dashboard.serviceTrend(params),
    () => CXCxDashboardApi.getServiceTrend(params),
    
  );
};

// Hook for consumption usage
export const useConsumptionUsage = (params: {
  remote_utility_id: any;
  utility_service: string;
}) => {
  return useSmartQuery(
    QueryKeyFactory.module.cx.dashboard.consumptionUsage(params),
    () => CXCxDashboardApi.getConsumptionUsage(params),
    
  );
};

// Hook for consumer card detail
export const useConsumerCardDetail = (params: {
  remote_utility_id: any;
}) => {
  return useSmartQuery(
    QueryKeyFactory.module.cx.dashboard.consumerCardDetail(params),
    () => CXCxDashboardApi.getConsumerCardDetail(params),
    
  );
};

// Hook for outstanding summary
export const useOutstandingSummary = (params: {
  remote_utility_id: any;
}) => {
  return useSmartQuery(
    QueryKeyFactory.module.cx.dashboard.outstandingSummary(params),
    () => CXCxDashboardApi.getOutstandingSummary(params),
   
  );
};

// Hook for monthly support summary
export const useMonthlySupportSummary = (params: {
  remote_utility_id: any;
}) => {
  return useSmartQuery(
    QueryKeyFactory.module.cx.dashboard.monthlySupportSummary(params),
    () => CXCxDashboardApi.getMonthlySupportSummary(params),
   
  );
};